<template>
    <!-- 登录 -->
    <div class="logins">
        <div class="logleft">
            <img :src="$img(txt)" alt="" />
        </div>
        <div class="tops">
            <div class="topTitle">
                忘记密码
            </div>
            <div class="ips">
                <div class="plItem flx alc">
                    <div class="phoneInp flx alc jsb">
                        <img :src="$Localimg('phoneIcon.png')" alt="" />
                        <input type="phone" placeholder="请输入手机号码" max-length="11" v-model="phone" />
                    </div>
                </div>
                <div class="plItem flx alc jsb" style="margin-top: 30px;">
                    <div class="phoneInp flx alc jsb" style="width: 245px;">
                        <img :src="$Localimg('gurdIcon.png')" alt="" />
                        <input type="phone" placeholder="请输入短信验证码" max-length="6" v-model="code" />
                    </div>
                    <div class="sendCode cursor" @click="sendCode">
                        {{ isCountDown ? `${count} 秒后重发` : '获取验证码' }}
                    </div>
                </div>
                <div class="plItem" style="margin-top: 30px;">
                    <div class="phoneInp flx alc jsb">
                        <img :src="$Localimg('locaIcon.png')" alt="" />
                        <input :type="inpType" placeholder="请设置密码" max-length="11" v-model="pwd" />
                        <img class="eyes" :src="$Localimg('eyeIcon.png')" v-if="inpType == 'password'"
                            @click="inpType = 'text'" alt="">
                        <img class="eyes" :src="$Localimg('openeye.png')" v-if="inpType == 'text'"
                            @click="inpType = 'password'" alt="">
                    </div>
                    <div class="tpis">密码提示：长度 8~10 位，必须同时包含字母（大小写不限）和数字，不支持特殊符号。</div>
                </div>
                <div class="plItem flx alc" style="margin-top: 30px;">
                    <div class="phoneInp flx alc jsb">
                        <img :src="$Localimg('locaIcon.png')" alt="" />
                        <input :type="inpType1" placeholder="请再次确认密码" max-length="11" v-model="pwd2" />
                        <img class="eyes" :src="$Localimg('eyeIcon.png')" v-if="inpType1 == 'password'"
                            @click="inpType1 = 'text'" alt="">
                        <img class="eyes" :src="$Localimg('openeye.png')" v-if="inpType1 == 'text'"
                            @click="inpType1 = 'password'" alt="">
                    </div>
                </div>
                <div class="flx alc rever">
                    <span class="bword" @click="tolog">继续登录</span>
                </div>
                <div class="Loginbtn cursor" style="margin-top: 23px;" @click="toLogin">
                    确认
                </div>
                <div class="rules flx alc jsc" style="margin-top: 30px;">
                    <div class="squ cursor" @click="hasRead = !hasRead"
                        :style="hasRead?'border:1px solid #007AFF' : ''">
                        <div class="inner" v-if="hasRead"></div>
                    </div>
                    <div class="rule">
                        我已阅读并同意 <b class="cursor" style="color:#007AFF" @click="toRule(2)">《隐私政策》</b> 和 <b
                            class="cursor" style="color:#007AFF" @click="toRule(1)">《用户协议》</b>
                    </div>
                </div>
            </div>
        </div>
        <div v-text="ttp" @click="toJump" class="ttp cursor"></div>
    </div>
</template>

<script>
    import {
        getConfig,
        sendCode,
        phoneLogin,
        codeLogin,
        userInfo,
        resetpwd
    } from "@/api/index.js"
    export default {
        name: 'Login',
        props: ['type'],
        data() {
            return {
                showLogin: false,
                inpType: "password",
                inpType1: "password",
                logo: "",
                cur: 0,
                phone: "",
                codeTxct: "获取验证码",
                code: "",
                sending: false,
                hasRead: false,
                isCountDown: false, // 是否正在倒计时
                count: 60, // 倒计时秒数
                timer: null, // 定时器
                pwd: "",
                show: false,
                isLogin: false,
                qrcode: "",
                pwd2: "",
                txt: "",
                ttp: ""
            }
        },
        mounted() {
            // this.nelog()
            let that = this
            that.cur = this.type
            getConfig().then((res) => {
                if (res.code == 1) {
                    that.txt = res.data.bg_login_text
                    that.ttp = res.data.beian
                }
            })
        },
        methods: {
            tolog() {
                this.$emit("logss")
            },
            closedo() {
                this.$emit("cal", 1)
            },
            changeType() {
                let that = this
                if (that.inpType == 'password') {
                    that.inpType = 'text'
                } else {
                    that.inpType = 'password'
                }
            },
            toJump() {
                window.open('https://beian.miit.gov.cn/#/Integrated/index')
            },
            toRule(e) {
                window.open('https://hrxsl.com/rules?type=' + e + '&t=' + Date.now(), '_blank');
            },
            toLogin() {
                let that = this
                if (that.hasRead == false) {
                    that.$message.warning('请仔细阅读《隐私政策》和《用户协议》')
                    return
                }
                let data = {}
                data.tel = that.phone
                data.yzm = that.code
                data.pwd = that.pwd
                data.pwd2 = that.pwd2
                data.type = that.cur + 1
                resetpwd(data).then((res) => {
                    if (res.code == 1) {
                        that.tolog()
                        this.$message.success(res.msg)
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            },
            // 发送验证码
            sendCode() {
                let that = this
                // 简单手机号校验
                if (!/^1[3-9]\d{9}$/.test(this.phone)) {
                    this.$message.warning('请输入正确的手机号')
                    return
                }
                // 模拟发送验证码接口
                console.log('发送验证码到：', this.phone)
                if (this.isCountDown == false) {
                    let data = {}
                    data.tel = that.phone
                    data.type = 2
                    sendCode(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            // 开始倒计时
                            this.isCountDown = true
                            let time = this.count
                            this.timer = setInterval(() => {
                                time--
                                this.count = time
                                if (time <= 0) {
                                    clearInterval(this.timer)
                                    this.isCountDown = false
                                    this.count = 60
                                }
                            }, 1000)
                            this.$message.success('验证码已发送')
                        } else {
                            that.$message.error(res.msg)
                        }
                    })

                }
            },
        }
    }
</script>
<style scoped>
    .logleft {
        position: absolute;
        left: 15%;
        top: 40%;
        transform: translateY(-50%);
        width: 40%;
    }

    .logleft img {
        width: 100%;
        height: auto;
    }

    .norword {
        font-weight: 500;
        font-size: 12px;
        color: #999999;
    }

    .ttp {
        position: absolute;
        bottom: 40px;
        text-align: center;
        width: 100%;
        color: #999;
        font-size: 14px;
    }

    .ips {
        box-sizing: border-box;
        padding: 30px;
    }

    .toptap {
        border-bottom: 1px solid #D9D9D9;
        margin-top: 24px;
    }

    .ttitem {
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        padding: 12px 0 0;
        position: relative;
        flex: 1;
        text-align: center;
    }

    .ttname {
        margin-bottom: 12px;
    }

    .ttheng {
        width: 22px;
        height: 2px;
        background: #007AFF;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
    }

    .tops {

        width: 420px;
        background: #fff;
        position: absolute;
        right: 8%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 20px;
    }

    .topTitle {
        font-size: 20px;
        color: #333333;
        font-weight: bold;
        box-sizing: border-box;
        padding: 30px 0 0;
        text-align: center;
    }

    .sh {
        color: #BEBEBE;
        font-size: 12px;
        margin: 0 12px;
    }

    .wechatlogin {
        margin-top: 18px;
    }

    .bword {
        font-weight: 500;
        font-size: 14px;
        color: #007AFF;
    }

    .rever {
        text-align: right;
        flex-direction: row-reverse;
        margin-top: 16px;
    }

    .pzhanghao {
        margin-top: 16px;
    }

    .pztitle {
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        margin-bottom: 12px;
    }

    .sarule {
        margin-top: 27px;
        font-size: 12px;
        color: #333;
    }

    .permethods {
        margin: 20px auto 0;
        box-sizing: border-box;
        padding: 0 54px;
    }

    .peitem img {
        width: 30px;
        height: 30px;
        margin-bottom: 8px;
    }

    .peitem {
        font-weight: 500;
        font-size: 12px;
        color: #999999;
    }

    .otname {
        margin: 0 24px;
        font-weight: 600;
        font-size: 12px;
        color: #73829D;
    }

    .otleft,
    .otright {
        width: 94px;
        height: 1px;
        background: #E9E9E9;
    }

    .regi {
        text-align: center;
        font-size: 12px;
        color: #007AFF;
        margin-top: 70px;
    }

    .logtips img {
        width: 14px;
        height: 14px;
        margin-right: 6px;
    }

    .logtips {
        font-weight: 500;
        font-size: 12px;
        color: #999999;
    }

    .wechat {
        margin-top: 40px;
        font-weight: 500;
        font-size: 20px;
        color: #333333;
    }

    .wechat img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
    }

    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }

    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }

    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }

    .Loginbtn {
        margin-bottom: 20px;
        width: 100%;
        height: 48px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 24px;
        text-align: center;
        line-height: 48px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        margin-top: 63px;
    }

    .sendCode {
        width: 91px;
        height: 48px;
        background: #F6F7F9;
        border-radius: 24px;
        text-align: center;
        line-height: 48px;
        font-size: 12px;
        color: #666666;
        font-weight: 500;
    }

    .phoneInp img {
        width: 18px;
        height: 18px;
    }

    .phoneInp input {
        flex: 1;
        box-sizing: border-box;
        padding: 0 8px;
        height: 100%;
        font-size: 14px;
        border: none !important;
        outline: none !important;
        background: transparent !important;
    }

    .phoneInp {
        width: 100%;
        height: 48px;
        background: #F6F7F9;
        border-radius: 24px;
        box-sizing: border-box;
        padding: 0 20px;
    }

    .phoneLogin {
        margin-top: 50px;
    }

    .cmActive {
        font-weight: 500 !important;
        font-size: 20px !important;
        color: #007AFF !important;
    }

    .heng {
        width: 32px;
        height: 3px;
        background: #007AFF;
        border-radius: 2px;
        margin: 10px auto 0;
    }

    .changeMetohds {
        box-sizing: border-box;
        padding: 20px 0;
    }

    .cmName {
        font-weight: 500;
        font-size: 20px;
        color: #999999;
    }

    .cmItem {
        margin: 0 24px;
        cursor: pointer;
    }

    .closeBtn {
        position: absolute;
        right: -50px;
        top: 0;
        cursor: pointer;
    }

    .logMethod img {
        width: 100%;
        height: 100%;
    }

    .logMethod {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        width: 55px;
        height: 55px;
    }

    .logContent {
        width: 420px;
        /* height: 711px; */
        background: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 20px;
        box-sizing: border-box;
        padding: 30px;
    }

    .logins {
        background-color: #fff;
        background: url('https://shop.hrxsl.com/images/loginback.png') no-repeat;
        background-size: 100% 100%;
        width: 100vw;
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1166 !important;
    }


    .pubItem {
        font-weight: 500;
        font-size: 16px;
        color: #151515;
        padding: 0 24px;
        cursor: pointer;
    }

    .el-header {
        padding: 0 !important;
    }

    .register {
        width: 83px;
        height: 115px;
        background: #007AFF;
        text-align: center;
        line-height: 115px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 115px;
        cursor: pointer;
    }

    .shu {
        width: 1px;
        height: 14px;
        background: #D9D9D9;
    }

    .pubs {
        flex: 1;
        justify-content: flex-end;
    }

    .search {
        margin-left: 259px;
    }

    .inp {
        width: 344px;
        height: 34px;
        border: 1px solid #007AFF;
    }

    .inp input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        font-weight: 500;
        font-size: 13px;
        box-sizing: border-box;
        padding: 0 10px;
    }

    .searchBtn {
        width: 86px;
        height: 34px;
        background: #007AFF;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #007AFF;
        text-align: center;
        line-height: 34px;
        font-weight: 500;
        font-size: 13px;
        color: #FFFFFF;
    }

    .hea {
        background: pink;
        height: 115px !important;
        background: #FFFFFF;
        box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.04);
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 230px !important;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 111;
        width: 100%;
    }

    .logo {
        width: 162px;
        height: 55px;

    }

    .logo img {
        width: 100%;
        height: 100%;
    }
</style>